var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.activitySettings
    ? _c(
        "div",
        [
          _c("ActivitySettingsSwitch", {
            attrs: {
              activitySettings: _vm.activitySettings,
              property: "enableCreateEmailNotifications"
            }
          }),
          _vm._v(" "),
          _c("ActivitySettingsSwitch", {
            attrs: {
              activitySettings: _vm.activitySettings,
              property: "enableCreatePushNotifications"
            }
          }),
          _vm._v(" "),
          _c("ActivitySettingsSwitch", {
            attrs: {
              activitySettings: _vm.activitySettings,
              property: "enableUpdateEmailNotifications"
            }
          }),
          _vm._v(" "),
          _c("ActivitySettingsSwitch", {
            attrs: {
              activitySettings: _vm.activitySettings,
              property: "enableUpdatePushNotifications"
            }
          }),
          _vm._v(" "),
          _c("ActivitySettingsSwitch", {
            attrs: {
              activitySettings: _vm.activitySettings,
              property: "enableResponsbileNotifications"
            }
          }),
          _vm._v(" "),
          _c("ActivitySettingsSwitch", {
            attrs: {
              activitySettings: _vm.activitySettings,
              property: "enableInventoryDownEmailNotifications"
            }
          }),
          _vm._v(" "),
          _c("ActivitySettingsSwitch", {
            attrs: {
              activitySettings: _vm.activitySettings,
              property: "enableCloseEmailNotifications"
            }
          }),
          _vm._v(" "),
          _c("ActivitySettingsSwitch", {
            attrs: {
              activitySettings: _vm.activitySettings,
              property: "enableClosePushNotifications"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }